export default {"src":"/_next/static/media/Male-01.564da203.svg","height":96,"width":96,"blurWidth":0,"blurHeight":0};